import { FC } from 'react';

const MainWindowContainer: FC = ({ children }) => {
  return (
    <div className="col-md-10 main-container position-relative">{children}</div>
  );
};

export default MainWindowContainer;
